export enum UomEnum {
    LB = 'lb',
    //*  IN_PROGRESS not in use.
    // IN_PROGRESS = 'IN_PROGRESS',
    KG = 'kg',
    OZ = 'oz',
    Gms = 'gm',
}



export enum DateEnum {
    ThreeToSixMonths = '3-6 Months',
    SixToTwelveMonths = '6-12 Months',
    OneYearAbove = '1 year Above',
    All = 'All (0-3 Months)',
}
